/* Серии тренировок и цитаты (прототип: mvp/client/assets/screens.js, CL_STK_MS/CL_QUOTES/CL_QUOTES_LOST/clQuoteNext).
   Рубежи — 3, 7, 14, 30, 50, 100, дальше каждые +50. Цитаты — только с надёжным авторством (не Конфуций/Черчилль
   из тех, что принято приписывать ошибочно), народное подписано пословицей. */
export const STREAK_MS = [3, 7, 14, 30, 50, 100];

/** Ближайший пройденный рубеж (не больше n) */
export function streakPrev(n: number): number {
  if (n >= 100) return Math.floor(n / 50) * 50;
  return [...STREAK_MS].reverse().find((m) => m <= n) || 0;
}
/** Следующий рубеж (больше n) */
export function streakNext(n: number): number {
  if (n >= 100) return streakPrev(n) + 50;
  return STREAK_MS.find((m) => m > n) ?? streakPrev(n) + 50;
}

export type Quote = [text: string, author: string];

export const QUOTES: Quote[] = [
  ['Путь в тысячу ли начинается с первого шага', 'Лао-цзы'],
  ['Побеждающий других силён, побеждающий себя — могуществен', 'Лао-цзы'],
  ['Девятиэтажная башня начинается с горстки земли', 'Лао-цзы'],
  ['Капля долбит камень', 'Овидий'],
  ['Терпи и крепись: эта боль когда-нибудь принесёт тебе пользу', 'Овидий'],
  ['Последние три-четыре повторения — вот что заставляет мышцы расти', 'Арнольд Шварценеггер'],
  ['Предел — только в голове', 'Арнольд Шварценеггер'],
  ['Жизнь — как езда на велосипеде: чтобы сохранить равновесие, нужно двигаться', 'Альберт Эйнштейн'],
  ['Пришёл, увидел, победил', 'Юлий Цезарь'],
  ['Упорный труд побеждает всё', 'Вергилий'],
  ['Ни один человек не ограничен', 'Элиуд Кипчоге'],
  ['Только дисциплинированные по-настоящему свободны', 'Элиуд Кипчоге'],
  ['Нет лёгкого пути от земли к звёздам', 'Сенека'],
  ['Мы не решаемся не потому, что трудно, — трудно потому, что не решаемся', 'Сенека'],
  ['Смелым помогает судьба', 'Теренций'],
  ['Пока мы откладываем, жизнь проходит мимо', 'Сенека'],
  ['Мы чаще страдаем в воображении, чем в действительности', 'Сенека'],
  ['Власть над собой — высшая власть', 'Сенека'],
  ['Поехали!', 'Юрий Гагарин'],
  ['Не можешь лететь — беги, не можешь бежать — иди, не можешь идти — ползи, но двигайся вперёд', 'Мартин Лютер Кинг'],
  ['Ты промахиваешься во всех бросках, которых не делаешь', 'Уэйн Гретцки'],
  ['Пределов нет — есть плато, и на них нельзя останавливаться', 'Брюс Ли'],
  ['Спеши медленно', 'Октавиан Август'],
  ['Сила не в физических возможностях, а в несгибаемой воле', 'Махатма Ганди'],
  ['Думаете вы, что можете, или что не можете, — вы правы', 'Генри Форд'],
  ['Ни дня без строчки', 'Плиний Старший'],
  ['Хорошо сделанное лучше хорошо сказанного', 'Бенджамин Франклин'],
  ['Кто начал, тот наполовину сделал', 'Гораций'],
  ['Победить себя — первая и лучшая из побед', 'Платон'],
  ['Ничто великое не создаётся вдруг', 'Эпиктет'],
  ['Сначала скажи себе, кем хочешь быть, а потом делай то, что нужно', 'Эпиктет'],
  ['Сделал дело — гуляй смело', 'Русская пословица'],
  ['Хватит рассуждать, каким должен быть хороший человек. Будь им', 'Марк Аврелий'],
  ['Недостаточно знать — надо применять. Недостаточно хотеть — надо делать', 'Иоганн Вольфганг Гёте'],
  ['Лучшее — враг хорошего', 'Вольтер'],
  ['В здоровом теле — здоровый дух', 'Ювенал'],
  ['Главное в жизни — не победа, а борьба', 'Пьер де Кубертен'],
  ['Быстрее, выше, сильнее', 'Олимпийский девиз'],
  ['Повторение — мать учения', 'Латинская пословица'],
  ['Через тернии — к звёздам', 'Латинское выражение'],
  ['Упражнение создаёт мастерство', 'Латинская пословица'],
  ['Терпение и труд всё перетрут', 'Русская пословица'],
  ['Дорогу осилит идущий', 'Пословица'],
  ['Тише едешь — дальше будешь', 'Русская пословица'],
  ['Без труда не выловишь и рыбку из пруда', 'Русская пословица'],
  ['Глаза боятся, а руки делают', 'Русская пословица'],
  ['Москва не сразу строилась', 'Русская пословица'],
  ['Не боги горшки обжигают', 'Русская пословица'],
  ['Лиха беда начало', 'Русская пословица'],
  ['Не откладывай на завтра то, что можно сделать сегодня', 'Пословица'],
];

export const QUOTES_LOST: Quote[] = [
  ['Упади семь раз, поднимись восемь', 'Японская пословица'],
  ['Пробовал. Ошибся. Неважно. Пробуй ещё. Ошибись ещё. Ошибись лучше', 'Сэмюэл Беккет'],
  ['Важно не то, как сильно ты бьёшь, а какой удар можешь выдержать и продолжать идти вперёд', 'Рокки Бальбоа'],
  ['Я снова и снова терпел неудачи. Именно поэтому я добился успеха', 'Майкл Джордан'],
  ['Я могу принять неудачу. Но не могу принять отказ от попытки', 'Майкл Джордан'],
  ['Что меня не убивает, делает меня сильнее', 'Фридрих Ницше'],
  ['Никогда не сдавайтесь — никогда, никогда, никогда', 'Уинстон Черчилль'],
  ['Огонь испытывает золото, а трудности — сильных людей', 'Сенека'],
  ['Что стоит на пути, то и становится путём', 'Марк Аврелий'],
  ['Неудача — просто возможность начать снова, но уже разумнее', 'Генри Форд'],
  ['Никто не побеждён, пока сам не признал поражение', 'Брюс Ли'],
  ['Нас тревожат не вещи, а наши суждения о них', 'Эпиктет'],
  ['Часто колючий шип рождает нежные розы', 'Овидий'],
  ['В трудный час сохраняй спокойствие духа', 'Гораций'],
  ['Человеку свойственно ошибаться', 'Латинская пословица'],
  ['Не ошибается тот, кто ничего не делает', 'Пословица'],
  ['За битого двух небитых дают', 'Русская пословица'],
  ['Первый блин комом', 'Русская пословица'],
];

export interface QuoteNextResult {
  quote: Quote;
  index: number;
  seen: number[];
}

/** Случайная непоказанная цитата; пул исчерпан — новый круг, но не `last` первой же (screens.js: clQuoteNext) */
export function quoteNext(pool: Quote[], seen: number[], last: number | null): QuoteNextResult {
  const seenSet = new Set(seen);
  let left = pool.map((_, i) => i).filter((i) => !seenSet.has(i));
  let nextSeen = seen;
  if (!left.length) {
    nextSeen = [];
    left = pool.map((_, i) => i).filter((i) => i !== last);
  }
  const index = left[Math.floor(Math.random() * left.length)];
  const seenOut = [...nextSeen, index];
  return { quote: pool[index], index, seen: seenOut };
}
